import { combineReducers } from 'redux';

import profilesReducer from './profiles';
import transactionsReducer from './transactions';

const identityReducer = combineReducers({
  profiles: profilesReducer,
  transactions: transactionsReducer,
});

export default identityReducer;
